/**
 * Copyright 2017, GeoSolutions Sas.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root dir
 ectory of this source tree.
 */

import withContainer from './WithContainer';
import { OverlayTrigger } from 'react-bootstrap';

export default withContainer(OverlayTrigger);
